module.exports = __webpack_public_path__ + "media/images/icon-close-7da7a55a7200dbbbd95e20320387a272.png";